import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputFile, InputMultiline, InputSelect, InputSwitch, InputUID, InputPicklist } from '../../components';
import BaseCopy from '../base/base-copy.component'; 
import Model from './event-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import MessagePicklist from '../message/message-picklist.component';
import SectionChecklist from '../section/section-checklist.component';
import PersonalinfoPicklist from '../personalinfo/personalinfo-picklist.component';
import PersonalinfoChecklist from '../personalinfo/personalinfo-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    id?: number;
    caption?: string;
    astemplate?: string;
    datarow?: any;
    save?: boolean;
    onSave?: (data: any) => void;
    onError?: (data: any) => void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
    save: boolean;
}

export default class EventCopy extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: {...Model.defaultValue(), astemplate: this.props.astemplate || 'no'},
            errors: null,
            datarowMedia: null,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private validations = [...Model.validations, {name: 'startdate', required: true, minValue: AppService.dateCurrent() }];
    
    private onLoad = async (data: any) => {
        await this.setState({datarow: {...data, ...this.props.datarow, uid: ''}});
        await this.onLoadFile(this.props.datarow?.image);
        this.setState({save: this.props.save || false});
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }

    private onLoadMessagestart = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'messagestart': data?.id, 'messagestartCaption': data?.name || ''  }  });
    }
    
    private onLoadMessageend = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'messageend': data?.id, 'messageendCaption': data?.name || ''  }  });
    }

    private onLoadSection = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'section': data || [], 'sectionCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }
    
    private onLoadCustomer = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'customer': data?.id, 'customerCaption': data?.name || ''  }  });
    }
    
    private onLoadParticipant = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'participant': data || [], 'participantCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }
    
    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }
    
    private onError = (data: any) => {
        if (data) {
            this.setState({errors: data, save: false});
            this.props.onError?.(data)
        }
    }
    
    private onSave = (data: any) => {
        this.setState({save: false});
        this.props.onSave?.(data)
    }

    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseCopy history={this.props.history} id={this.props.id} caption={this.state.datarow.parent && 'Duplicate Event Section'}
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} validations={this.validations} onLoad={this.onLoad} onError={this.onError} save={this.state.save} onSave={this.onSave} disableAutoBack={this.props.disableView} disableBackButton={this.props.disableView}>              
                
                {!this.props.disableView &&
                <>
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange} />
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                {this.state.datarow.parent &&
                <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                }
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} error={this.state.errors?.type} onChange={this.onChange} readOnly={this.state.datarow.parent}/>
                <InputSelect name='viewstyle' label='View Style' value={this.state.datarow.viewstyle} options={Model.optionViewstyle} error={this.state.errors?.viewstyle} onChange={this.onChange} readOnly={this.state.datarow.parent}/>
                <InputSwitch name='usecamera' label='Use Camera' value={this.state.datarow.usecamera} error={this.state.errors?.usecamera} onChange={this.onChange}/>
                <InputSwitch name='extratime' label='Allow Extra Time' value={this.state.datarow.extratime} error={this.state.errors?.extratime} onChange={this.onChange}/>
                {!this.state.datarow.parent && <>
                <InputPicklist name='messagestart' label='Message to Send Invitation' value={this.state.datarow.messagestart} caption={this.state.datarow.messagestartCaption} clearValue={this.onLoadMessagestart} error={this.state.errors?.messagestart} onChange={this.onChange} >
                    <MessagePicklist currentId={this.state.datarow.messagestart} onLoad={this.onLoadMessagestart} astemplate='yes'/>
                </InputPicklist>
                <InputPicklist name='messageend' label='Message to Send Result' value={this.state.datarow.messagestart} caption={this.state.datarow.messageendCaption} clearValue={this.onLoadMessageend} error={this.state.errors?.messageend} onChange={this.onChange} >
                    <MessagePicklist currentId={this.state.datarow.messageend} onLoad={this.onLoadMessageend} astemplate='yes'/>
                </InputPicklist>
                </>}
                <InputPicklist name='section' label='Section' value={this.state.datarow.section} caption={this.state.datarow.sectionCaption} disableAutoClose clearValue={this.onLoadSection} error={this.state.errors?.section} onChange={this.onChange}>
                    <SectionChecklist history={this.props.history} currentId={this.state.datarow.section} tag='quiz' onLoad={this.onLoadSection} disableBackButton/>
                </InputPicklist> 
                {!this.state.datarow.parent &&
                <InputPicklist name='customer' label='Customer' value={this.state.datarow.customer} caption={this.state.datarow.customerCaption} error={this.state.errors?.customer} clearValue={this.onLoadCustomer} onChange={this.onChange} >
                    <PersonalinfoPicklist currentId={this.state.datarow.customer} onLoad={this.onLoadCustomer}/>
                </InputPicklist>
                }
                <InputPicklist name='participant' label='Participant' value={this.state.datarow.participant} caption={this.state.datarow.participantCaption} disableAutoClose clearValue={this.onLoadParticipant} error={this.state.errors?.participant} onChange={this.onChange}>
                    <PersonalinfoChecklist history={this.props.history} caption='Select Participant' personalinfotypeType='customer' currentId={this.state.datarow.participant} onLoad={this.onLoadParticipant} disableBackButton/>
                </InputPicklist> 
                <InputDate name='startdate' label='Start Date' value={this.state.datarow.startdate} clearValue error={this.state.errors?.startdate} onChange={this.onChange} />
                <InputDate name='enddate' label='End Date' value={this.state.datarow.enddate} clearValue error={this.state.errors?.enddate} onChange={this.onChange} />
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                <InputUID name='uid' label='QR Code' value={this.state.datarow.uid} error={this.state.errors?.uid} onChange={this.onChange} />               
                </>
                }
            </BaseCopy>
        );
    }
}